var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgLockIcon = function SvgLockIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9 6V4c0-1.102-.898-2-2-2-1.102 0-2 .898-2 2v2h4zm3 0c1.11 0 2 .898 2 2v6c0 1.102-.89 2-2 2H2c-1.102 0-2-.898-2-2V8c0-1.102.898-2 2-2h1V4c0-2.21 1.79-4 4-4s4 1.79 4 4v2h1zm-3.594 8l-.57-2.719A1.75 1.75 0 008.75 9.75C8.75 8.781 7.969 8 7 8c-.96 0-1.75.781-1.75 1.75 0 .664.375 1.234.914 1.531L5.602 14h2.804z"
  })));
};
export default SvgLockIcon;